module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }